export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        {/* Visual Image */}
        <div className="rounded-2xl overflow-hidden mb-8 md:mb-10 max-w-2xl mx-auto">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20product%20flatlay%20composition%20with%20curated%20sneakers%20clothing%20and%20accessories%20beautifully%20arranged%20on%20warm%20sand%20colored%20linen%20surface%20soft%20natural%20daylight%20creating%20delicate%20long%20shadows%20clean%20editorial%20european%20aesthetic%20with%20muted%20terra%20cotta%20and%20sage%20green%20accents%20organic%20textures%20calm%20luxurious%20atmosphere%20with%20film%20grain%20texture&width=900&height=500&seq=cta-hoobuy-v2-01&orientation=landscape"
            alt="HoobuySpreadsheet products"
            className="w-full h-auto object-cover"
          />
        </div>

        {/* CTA Copy */}
        <p className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-900 leading-snug max-w-2xl mx-auto">
          Acesse agora o{' '}
          <span className="italic text-primary-600">HoobuySpreadsheet</span> atualizado e descubra
          produtos antes de todo mundo
        </p>

        <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-xl mx-auto">
          Não perca tempo procurando. Nossa planilha organizada tem tudo que você precisa em um só lugar.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 text-sm md:text-base font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            VER HOOBUYSPREADSHEET AGORA
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 text-sm md:text-base font-medium rounded-full border-2 border-foreground-200 text-foreground-700 hover:bg-foreground-50 transition-all whitespace-nowrap cursor-pointer"
          >
            Acessar Site Principal
            <i className="ri-external-link-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}